const stateHighlights = {
  andhra_pradesh: {
    food: "Pulihora, Gongura Pachadi",
    festival: "Ugadi, Sankranti",
    dress: "Dhoti, Saree",
    animal: "Blackbuck",
  },

  arunachal_pradesh: {
    food: "Thukpa, Momos",
    festival: "Losar, Solung",
    dress: "Traditional Tribal Wear",
    animal: "Mithun",
  },

  assam: {
    food: "Khar, Masor Tenga",
    festival: "Bihu",
    dress: "Mekhela Chador",
    animal: "One-horned Rhinoceros",
  },

  bihar: {
    food: "Litti Chokha, Thekua",
    festival: "Chhath Puja",
    dress: "Dhoti Kurta, Saree",
    animal: "Gaur",
  },

  chhattisgarh: {
    food: "Chila, Faraa",
    festival: "Bastar Dussehra",
    dress: "Lugda",
    animal: "Wild Buffalo",
  },

  goa: {
    food: "Fish Curry, Bebinca",
    festival: "Carnival, Shigmo",
    dress: "Kunbi Saree",
    animal: "Gaur",
  },

  gujarat: {
    food: "Dhokla, Thepla",
    festival: "Navratri, Uttarayan",
    dress: "Chaniya Choli",
    animal: "Asiatic Lion",
  },

  haryana: {
    food: "Bajra Khichdi, Kadhi",
    festival: "Teej, Baisakhi",
    dress: "Ghagra, Dhoti",
    animal: "Blackbuck",
  },

  himachal_pradesh: {
    food: "Dham, Siddu",
    festival: "Kullu Dussehra",
    dress: "Pattu",
    animal: "Snow Leopard",
  },

  jharkhand: {
    food: "Dhuska, Rugra",
    festival: "Sarhul",
    dress: "Traditional Tribal Wear",
    animal: "Elephant",
  },

  karnataka: {
    food: "Bisi Bele Bath, Mysore Pak",
    festival: "Mysuru Dasara",
    dress: "Ilkal Saree",
    animal: "Elephant",
  },

  kerala: {
    food: "Sadya, Appam",
    festival: "Onam, Vishu",
    dress: "Kasavu Saree",
    animal: "Elephant",
  },

  madhya_pradesh: {
    food: "Poha, Bhutte Ka Kees",
    festival: "Khajuraho Festival",
    dress: "Lehenga, Dhoti",
    animal: "Barasingha",
  },

  maharashtra: {
    food: "Puran Poli, Misal Pav",
    festival: "Ganesh Chaturthi, Gudi Padwa",
    dress: "Nauvari Saree",
    animal: "Indian Giant Squirrel",
  },

  manipur: {
    food: "Eromba, Chamthong",
    festival: "Yaoshang",
    dress: "Phanek",
    animal: "Sangai Deer",
  },

  meghalaya: {
    food: "Jadoh, Tungrymbai",
    festival: "Wangala",
    dress: "Jainsem",
    animal: "Clouded Leopard",
  },

  mizoram: {
    food: "Bai, Sawhchiar",
    festival: "Chapchar Kut",
    dress: "Puan",
    animal: "Serow",
  },

  nagaland: {
    food: "Smoked Pork, Bamboo Shoot",
    festival: "Hornbill Festival",
    dress: "Naga Shawl",
    animal: "Mithun",
  },

  odisha: {
    food: "Dalma, Pakhala Bhata",
    festival: "Rath Yatra",
    dress: "Sambalpuri Saree",
    animal: "Sambar Deer",
  },

  punjab: {
    food: "Makki Di Roti, Lassi",
    festival: "Lohri, Baisakhi",
    dress: "Punjabi Suit",
    animal: "Blackbuck",
  },

  rajasthan: {
    food: "Dal Baati Churma",
    festival: "Gangaur, Teej",
    dress: "Ghagra Choli",
    animal: "Camel",
  },

  sikkim: {
    food: "Momos, Thukpa",
    festival: "Losar",
    dress: "Bakhu",
    animal: "Red Panda",
  },

  tamil_nadu: {
    food: "Idli, Dosa",
    festival: "Pongal",
    dress: "Kanchipuram Saree",
    animal: "Nilgiri Tahr",
  },

  telangana: {
    food: "Hyderabadi Biryani, Sarva Pindi",
    festival: "Bathukamma",
    dress: "Pochampally Saree",
    animal: "Spotted Deer",
  },

  tripura: {
    food: "Mui Borok",
    festival: "Kharchi Puja",
    dress: "Rignai",
    animal: "Phayre's Leaf Monkey",
  },

  uttar_pradesh: {
    food: "Tunday Kebab, Petha",
    festival: "Kumbh Mela, Holi",
    dress: "Kurta Pajama",
    animal: "Swamp Deer",
  },

  uttarakhand: {
    food: "Kafuli, Bal Mithai",
    festival: "Nanda Devi Raj Jat",
    dress: "Ghagra, Pichora",
    animal: "Musk Deer",
  },

  west_bengal: {
    food: "Rosogolla, Fish Curry",
    festival: "Durga Puja",
    dress: "Tant Saree",
    animal: "Fishing Cat",
  },
};

export default stateHighlights;